import { PhotosSelectAllUnverifiedPhotosReducer } from './types';

export const photosSelectAllUnverifiedPhotosReducer: PhotosSelectAllUnverifiedPhotosReducer =
  (state) => {
    return {
      ...state,
      selectedPhotos: state.unverifiedPhotos?.map((photo) => photo.id) || [],
    };
  };
